/**
 *
 * ChangeRoleDialog constants
 *
 */

export const OPEN_CHANGE_ROLE_DIALOG = 'claris-vnext/ChangeRoleDialog/OPEN_CHANGE_ROLE_DIALOG';
export const ACCEPT_CHANGE_ROLE_DIALOG = 'claris-vnext/ChangeRoleDialog/ACCEPT_CHANGE_ROLE_DIALOG';
export const CLOSE_CHANGE_ROLE_DIALOG = 'claris-vnext/ChangeRoleDialog/CLOSE_CHANGE_ROLE_DIALOG';
